import React, { useEffect } from "react";
import "./Exclusive.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Exclusive_Card from "./exclusive_card/Exclusive_Card";
import { useDispatch, useSelector } from "react-redux";
import { AllInsightExclusive } from "../../../../features/admin/common/Slice";
import { IDS } from "../../../../utils/IDS";

const Exclusive = () => {
  const data = [
    {
      views: "56k",
      uploadedDate: "3",
      img: "/assets/images/insight/banner/img1.png",
    },
    {
      views: "46k",
      uploadedDate: "2",
      img: "/assets/images/insight/banner/img2.png",
    },
    {
      views: "6k",
      uploadedDate: "31",
      img: "/assets/images/insight/banner/img1.png",
    },
    {
      views: "6k",
      uploadedDate: "31",
      img: "/assets/images/insight/banner/img1.png",
    },
  ];


  const dispatch = useDispatch();
  const exclusives = useSelector((state) => state.common.all_insight_exclusives);


  useEffect(() => {
    dispatch(AllInsightExclusive());
  }, [dispatch])

  function daysAgo(dateString) {
    if (!dateString) return "";

    const givenDate = new Date(dateString);
    const today = new Date();

    if (isNaN(givenDate)) return "";

    const diffTime = today - givenDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays <= 0) return "Today";
    if (diffDays === 1) return "1 day ago";
    if (diffDays < 30) return `${diffDays} days ago`;

    const months = Math.floor(diffDays / 30);
    if (months < 12)
      return months === 1 ? "1 month ago" : `${months} months ago`;

    const years = Math.floor(months / 12);
    return years === 1 ? "1 year ago" : `${years} years ago`;
  }


  return (
    <section className="Exclusive">
      <div className="container">
        {/* <p className="page_title_text">INSIGHT</p> */}
        <div className="main_white_card">
          <p className="title_text">EXCLUSIVE</p>

          <div className="exclusive_swiper_div">
            <Swiper
              className=""
              // navigation={true}
              spaceBetween={16}
              slidesPerView={2}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              modules={[Autoplay]}
              pagination={{ clickable: true }}
              breakpoints={{
                0: { slidesPerView: 1.2 },
                380: { slidesPerView: 1.7 },
                576: { slidesPerView: 2 },
                768: { slidesPerView: 2.3 },
                992: { slidesPerView: 3 },
                1200: { slidesPerView: 3 },
              }}
            >
              {exclusives?.slice(0, 4)?.map((item, index) => {
                const days = daysAgo(item?.days);
                return (
                  <SwiperSlide key={index}>
                    <Exclusive_Card
                      link={item?.link}
                      views={item?.view || "0"}
                      img={IDS.IMG_URL + item?.image}
                      uploadedDate={days || "0"}
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Exclusive;
